import React from "react";
import { connect } from "react-redux";
import { getTipoDocumento } from "../tiposDocumento/TipoDocumentoService";
import Navbar from "../home/Navbar";
import "../../styles/Empresa.css";
import DocumentDialogContent from "../tiposDocumento/NuevoTipoDocumento";
import TiposDocumentoDatos from "../tiposDocumento/TiposDocumentoDatos";
import { desactivarTipoDocumento } from "../tiposDocumento/TipoDocumentoService";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import "../../scripts.jsx";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { esSesionAdmin } from "../usuario/Usuario";
import delete_forever from "../../styles/icons/delete.svg";
import edit from "../../styles/icons/edit.svg";
import visibility from "../../styles/icons/visibility.svg";
import settings_backup_restore from "../../styles/icons/settings_backup_restore.svg";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class TiposDocumentos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nuevo Tipo de Documento",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedTipoDocumento: {
        nombre: "",
        formato: "",
        firmaEmpresa: true,
        acciones: "",
        id: "",
      },
      nuevoTipoDocumento: false,
      editarTipoDocumento: false,
      verTipoDocumento: false,
      eliminarTipoDocumento: false,
      restaurarTipoDocumento: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "success",
      openPantallaCarga: false,
      pageSize: 10,
      search:"",
      loading: true
    };
    this.tableRef = React.createRef();
  }


  handleOpenNuevoTipoDocumento = () => {
    this.setState({ nuevoTipoDocumento: true });
  };

  handleCloseNuevoTipoDocumento = (mensaje = "", severity = "") => {
    this.fetchDocumentos(0, this.state.pageSize, "");
    if (mensaje != "") {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: mensaje,
        mensajeFlashSeverity: severity,
      });
    }
    this.setState({ nuevoTipoDocumento: false });
  };

  handleOpenEditarTipoDocumento = () => {
    this.setState({ editarTipoDocumento: true });
  };

  handleCloseEditarTipoDocumento = (mensaje = "", severity = "") => {
    if (mensaje != "") {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: mensaje,
        mensajeFlashSeverity: severity,
      });
    }
    this.setState({ editarTipoDocumento: false });
    this.fetchDocumentos(0, this.state.pageSize, "");
  };

  handleDialogVerDatos = (value) => {
    this.setState({
      verTipoDocumento: value,
    });
  };

  handleDialogEliminarDocumento = (value) => {
    this.setState({
      eliminarTipoDocumento: value,
    });
  };

  handleDialogRestaurarDocumento = (value) => {
    this.setState({
      restaurarTipoDocumento: value,
    });
  };

  handleDelete = () => {
    this.setState({
      openPantallaCarga: true,
      eliminarTipoDocumento: false,
    });
    desactivarTipoDocumento(this.state.selectedTipoDocumento.id).then((res) => {
      this.setState({
        openPantallaCarga: false,
        open: false,
        mostrarMensajeFlash: true,
        mensajeFlash: res.mensaje,
      });
      if (!res.error) this.setState({ mensajeFlashSeverity: "success" });
      else this.setState({ mensajeFlashSeverity: "danger" });

      this.fetchDocumentos(0, this.state.pageSize, "");
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchDocumentos(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchDocumentos(0, this.state.pageSize, "");
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchDocumentos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchDocumentos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchDocumentos(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getTipoDocumento(page, pageSize, search).then(() => {
      this.setState({
        documentos: this.props.tipoDocumentoData.tipoDocumento,
        page: this.props.tipoDocumentoData.page,
        totalCount: this.props.tipoDocumentoData.totalCount,
        totalPages: Math.ceil(
          this.props.tipoDocumentoData.totalCount / pageSize
        ),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchDocumentos(0, this.state.pageSize, this.state.search);
    });
  };

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <PantallaCarga open={this.state.openPantallaCarga} />

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.eliminarTipoDocumento}
              onHide={() => this.handleDialogEliminarDocumento(false)}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <img
                        src={ExclamacionIcon}
                        style={{ margin: "40px" }}
                      ></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p>
                        <strong>
                          ¿Está seguro que desea eliminar el documento
                          seleccionado?
                        </strong>
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col style={{ marginTop: "15px" }}>
                      <p>
                        <strong>Nombre de Documento: </strong>
                        {this.state.selectedTipoDocumento.nombre}
                      </p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    onClick={() => this.handleDialogEliminarDocumento(false)}
                    variant="contained"
                  >
                    Cancelar
                  </Button>
                  <Button onClick={this.handleDelete} color="primary" autoFocus>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>

            <Modal
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.editarTipoDocumento}
              onHide={this.handleCloseEditarTipoDocumento}
              backdrop="static"
              keyboard="false"
            >
              <DocumentDialogContent
                id={this.state.selectedTipoDocumento.id}
                handleClose={this.handleCloseEditarTipoDocumento}
                type="edit"
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle="Editar documento"
              />
            </Modal>

            <Modal
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.nuevoTipoDocumento}
              onHide={this.handleCloseNuevoTipoDocumento}
              backdrop="static"
              keyboard="false"
            >
              <DocumentDialogContent
                id={this.state.selectedTipoDocumento.id}
                handleClose={this.handleCloseNuevoTipoDocumento}
                type="add"
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle="Nuevo tipo documento"
              />
            </Modal>

            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.verTipoDocumento}
              onHide={() => this.handleDialogVerDatos(false)}
              backdrop="static"
              keyboard="false"
            >
              <TiposDocumentoDatos
                id={this.state.selectedTipoDocumento.id}
                disabledInput={this.state.disabledInput}
                dialogTitle="Ver documento"
              />
            </Modal>

            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash}
            />

            <div className="sectionHeader">
              <h1 className="pageTitle"> Tipos Documentos </h1>
              {!esSesionAdmin() && (
                <div className="actions">
                  <a
                    className="btn btn-primary"
                    onClick={this.handleOpenNuevoTipoDocumento}
                  >
                    {" "}
                    Nuevo Documento{" "}
                  </a>
                </div>
              )}
            </div>

            <Navbar
              menuActual={window.location.hash}
              seccionActual={
                !esSesionAdmin() ? "configuracion" : "administracion"
              }
            />
            <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>

              <div className="contentPage card" style={{ padding: "0px" }}>
              {this.state.loading ? (
              // Muestra el spinner mientras loading sea true
              <div className="d-flex justify-content-center p-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              </div>
            ) : ( <div>
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      {!esSesionAdmin() ? (
                        <tr>
                          <th scope="col">Nombre</th>
                          <th scope="col">Formato de importacion</th>
                          <th scope="col">Acciones del Colaborador</th>
                          <th scope="col">Firma de Empresa</th>
                          <th scope="col">Acciones</th>
                        </tr>
                      ) : (
                        <tr>
                          <th scope="col">Nombre</th>
                          <th scope="col">Formato de importacion</th>
                          <th scope="col">Empresa</th>
                          <th scope="col">Activo</th>
                          <th scope="col">Acciones</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {this.props.tipoDocumentoData.tipoDocumento.map(
                        (documento, index) =>
                          !esSesionAdmin() ? (
                            <tr key={index}>
                              <th scope="row">{documento.nombre}</th>
                              <td>{documento.formato}</td>
                              <td>{documento.tipoFirmaEmpleado}</td>
                              <td>{documento.firmaEmpresa ? "SI" : "NO"}</td>
                              <td>
                                <div className="table-actions">
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          selectedTipoDocumento: documento,
                                          dialogType: "edit",
                                          disabledInput: false,
                                        },
                                        () => {
                                          this.setState({
                                            mostrarMensajeFlash: false,
                                          });
                                          this.handleOpenEditarTipoDocumento();
                                        }
                                      );
                                    }}
                                  >
                                    <img src={edit} alt="Editar" />
                                  </a>
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          dialogTitle: "Ver tipo de Documento",
                                          selectedTipoDocumento: documento,
                                          dialogType: "ver",
                                          submitText: "Ver",
                                          disabledInput: false,
                                        },
                                        () => {
                                          this.handleDialogVerDatos(true);
                                        }
                                      );
                                    }}
                                  >
                                    <img src={visibility} alt="Ver" />
                                  </a>
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          selectedTipoDocumento: documento,
                                          dialogType: "edit",
                                          submitText: "Editar",
                                          disabledInput: false,
                                        },
                                        () => {
                                          this.handleDialogEliminarDocumento(
                                            true
                                          );
                                        }
                                      );
                                    }}
                                  >
                                    <img src={delete_forever} alt="Eliminar" />
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr key={index}>
                              <th scope="row">{documento.nombre}</th>
                              <td>{documento.formato}</td>
                              <td>{documento.tipoFirmaEmpleado}</td>
                              <td>{documento.firmaEmpresa ? "SI" : "NO"}</td>
                              <td>
                                <div className="table-actions">
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          dialogTitle: "Ver tipo de Documento",
                                          selectedTipoDocumento: documento,
                                          dialogType: "ver",
                                          submitText: "Ver",
                                          disabledInput: false,
                                        },
                                        () => {
                                          this.handleDialogVerDatos(true);
                                        }
                                      );
                                    }}
                                  >
                                    <img src={visibility} alt="Ver" />
                                  </a>
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      if (documento.activo) {
                                        this.setState(
                                          {
                                            selectedTipoDocumento: documento,
                                            dialogType: "edit",
                                            submitText: "Editar",
                                            disabledInput: false,
                                          },
                                          () => {
                                            this.handleDialogEliminarDocumento(
                                              true
                                            );
                                          }
                                        );
                                      }
                                    }}
                                  >
                                    <img src={delete_forever} alt="Eliminar" />
                                  </a>
                                  <a
                                    className="btn btn-secondary btn-md btn-floating"
                                    onClick={() => {
                                      if (!documento.activo) {
                                        this.setState(
                                          {
                                            selectedTipoDocumento: documento,
                                            dialogType: "edit",
                                            submitText: "Editar",
                                            disabledInput: false,
                                          },
                                          () => {
                                            this.handleDialogRestaurarDocumento(
                                              true
                                            );
                                          }
                                        );
                                      }
                                    }}
                                  >
                                    <img
                                      src={settings_backup_restore}
                                      alt="Restaurar"
                                    />
                                  </a>
                                </div>
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>
                <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>)}
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getTipoDocumento: (page, size, search) =>
    dispatch(getTipoDocumento(page, size, search)),
});

const mapStateToProps = (state) => ({
  tipoDocumentoData: state.tipoDocumentoData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TiposDocumentos);
